import * as React from "react";
import * as styles from "../styles/poweredBy.module.scss";

const BRAND_COLORS = [
  "#37A47F",
  "#FFBD0A",
  "#F94C77",
  "#5AB9EA",
  "#43D787",
  "#FFC107",
  "#E53935",
];

const AesiLogoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 512 512">
    <path
      fill="#009688"
      fillRule="evenodd"
      d="M255.765 231.999 75.103 129.806s-8.212-5.474-16.424-1.825-8.212 14.599-8.212 14.599v208.947s-.456 10.037 1.825 14.599c2.281 4.563 11.862 10.037 11.862 10.037l177.012 101.28v10.037s0 15.511 15.511 15.511c15.512 0 15.512-15.511 15.512-15.511v-10.037l176.099-101.28s8.212-4.562 10.949-10.037c2.738-5.474 2.738-14.599 2.738-14.599V142.58s.912-10.036-8.212-14.599c-9.125-4.562-18.249 1.825-18.249 1.825zm16.424 179.749V296.781s0-15.511-15.512-15.511c-15.511 0-15.511 15.511-15.511 15.511v114.967s.912 11.862-7.3 16.424-17.336-.913-17.336-.913L94.264 356.09s-6.387-2.738-9.124-6.387c-2.737-3.65-2.737-10.95-2.737-10.95V197.326s-.913-10.036 6.387-14.599c7.3-4.562 16.423.913 16.423.913l135.04 77.557s10.037 6.387 15.512 6.387 16.424-7.3 16.424-7.3l135.04-77.557s8.212-4.562 15.511 0 6.387 14.599 6.387 14.599v141.427s0 6.387-.912 9.125c-.913 2.737-10.037 8.212-10.037 8.212l-124.091 72.082s-9.124 3.649-15.511 0-6.387-16.424-6.387-16.424"
      clipRule="evenodd"
    />
    <path
      fill="#009688"
      d="M238.428 25.79c0-9.575 7.762-17.337 17.336-17.337 9.575 0 17.337 7.762 17.337 17.337v164.237c0 9.575-7.762 17.337-17.337 17.337s-17.336-7.762-17.336-17.337zm47.447 27.373c0-9.575 7.762-17.337 17.337-17.337s17.336 7.762 17.336 17.337v109.491c0 9.575-7.762 17.337-17.336 17.337-9.575 0-17.337-7.762-17.337-17.337zm-94.894 0c0-9.575 7.762-17.337 17.337-17.337s17.336 7.762 17.336 17.337v109.491c0 9.575-7.762 17.337-17.336 17.337-9.575 0-17.337-7.762-17.337-17.337zm-47.445 27.373c0-9.575 7.761-17.337 17.336-17.337s17.336 7.762 17.336 17.337v54.745c0 9.575-7.761 17.337-17.336 17.337s-17.336-7.762-17.336-17.337zm189.786 0c0-9.575 7.762-17.337 17.337-17.337s17.336 7.762 17.336 17.337v54.745c0 9.575-7.762 17.337-17.336 17.337-9.575 0-17.337-7.762-17.337-17.337zm47.446 27.373c0-9.575 7.762-17.336 17.336-17.336 9.575 0 17.336 7.761 17.336 17.336s-7.761 17.336-17.336 17.336-17.336-7.762-17.336-17.336m-284.679 0c0-9.575 7.762-17.336 17.336-17.336 9.575 0 17.336 7.761 17.336 17.336s-7.761 17.336-17.336 17.336-17.336-7.762-17.336-17.336"
    />
  </svg>
);

export default function PoweredBy({
  companyName = "AESi",
  href = "https://www.aesiph.com/",
  color,
}) {
  const circles = Array.from({ length: 16 }, (_, i) => ({
    id: i,
    color: BRAND_COLORS[i % BRAND_COLORS.length],
  }));

  const logos = Array.from({ length: 8 }, (_, i) => ({
    id: i,
  }));

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={styles.poweredBy}
      aria-label={`Powered by ${companyName}`}
      onClick={() => {
        window.gtag?.("event", "select_content", {
          content_type: "navigation",
          content_id: "aesi_click",
          menu_type: "footer",
          destination: href,
          page_location: window.location.pathname,
        });
      }}
    >
      <span className={styles.text} style={color ? { color } : undefined}>
        Powered by {companyName}
      </span>

      {/* Multiple SVG Logo particles */}
      {logos.map((logo) => (
        <span
          key={`logo-${logo.id}`}
          className={styles.logoParticle}
          style={{
            "--delay": `${logo.id * 0.05}s`,
          }}
          aria-hidden="true"
        >
          <AesiLogoSvg />
        </span>
      ))}

      {circles.map((circle) => (
        <span
          key={circle.id}
          className={styles.circle}
          style={{
            "--delay": `${circle.id * 0.03}s`,
            "--color": circle.color,
          }}
          aria-hidden="true"
        />
      ))}
    </a>
  );
}
